module.exports = __webpack_public_path__ + "img/c97.af62a47f.png";